import { jsx } from "panel";
import { SegmentFilterDataTableEl } from "common/charts/misc/segment-filter-data-table";
import { Theme, TrackName as DataTableTrackName } from "common/components/data-table/types";
import { ActionsPopoverEl } from "common/widgets/actions-popover";
import { handlePopoverAction } from "common/report/retention/visualization/popover";
import { popoverBody } from "common/report/retention/visualization/popoverBody";
export function template() {
  const { popoverState } = this.state;
  const isSegmented = this.state.bookmarkController.getSegments().length > 0;
  return /* @__PURE__ */ jsx("div", { sel: ".retention-table" }, this.hasResults() ? /* @__PURE__ */ jsx("div", { sel: ".table-container" }, /* @__PURE__ */ jsx(
    SegmentFilterDataTableEl,
    {
      attrs: {
        elref: `dataTable`,
        "track-name": DataTableTrackName.RetentionCurve,
        collapsible: true,
        theme: Theme.Retention,
        "resizing-layout": this.params.resizingLayout,
        "selected-cell": this.getSelectedCell()
      },
      on: {
        collapseChange: this.handleCollapseChange,
        sortChange: this.handleSortChange,
        cellClick: this.handleCellClick,
        tableScroll: () => this.handlePopoverChange(false)
      }
    }
  )) : /* @__PURE__ */ jsx("div", { sel: ".retention-no-data" }, /* @__PURE__ */ jsx("div", { sel: ".retention-no-data-img" }), /* @__PURE__ */ jsx("div", { sel: ".retention-no-data-text" }, "We couldn't find any data for your query.")), (popoverState == null ? void 0 : popoverState.open) ? /* @__PURE__ */ jsx(
    ActionsPopoverEl,
    {
      attrs: {
        open: popoverState.open,
        title: popoverState.popover.getTitle(),
        subtitle: popoverState.popover.getSubtitle(),
        "button-options": popoverState.popover.getButtonOptions(),
        "is-segmented": isSegmented,
        "prevent-close-selectors": [`.data-cell`, `.mp-table-cell`],
        "project-id": this.params.projectId
      },
      props: {
        positionParent: popoverState.targetCell
      },
      on: {
        action: (ev) => handlePopoverAction({
          action: ev.detail.action,
          color: popoverState.bgColor,
          popover: popoverState.popover,
          updateUserSidebarContextFn: (isOpen) => this.getContext(`reportLayoutManager`).updateIsUserSidebarOpen(isOpen)
        }),
        close: () => this.handlePopoverChange(false)
      }
    },
    popoverBody({
      isAggregate: popoverState.popover.isAggregatedCell(),
      retainedCount: popoverState.popover.getRetainedCount(),
      dataGroupName: popoverState.popover.getDataGroupName(),
      dataGroupNamePlural: popoverState.popover.getDataGroupNamePlural(),
      retainedPercent: popoverState.retainedPercent,
      dropOffCount: popoverState.popover.getDropOffCount(),
      dropOffPercent: popoverState.dropOffPercent,
      propertyAggregation: popoverState.popover.getPropertyAggregation()
    })
  ) : null);
}
